var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isConfigLoaded)?_c('Markdown',{attrs:{"markdown-config":_vm.markdownConfig,"enable_beta_markdown_export":_vm.config.enable_beta_markdown_export,"export-link":_vm.exportUrl,"download-endpoint":_vm.stsUrl(_vm.config)},on:{"onEdit":_vm.onEdit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }